<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部" name=""></el-tab-pane>
      <el-tab-pane label="点播课" name="1"></el-tab-pane>
      <el-tab-pane label="直播课" name="2"></el-tab-pane>
      <el-tab-pane label="预约课" name="3"></el-tab-pane>
    </el-tabs>

    <div
      class="classitems clearfix"
      v-for="(item) in contountbox.arr"
      :data-id="item.id"
      :key="item.id"
    >
      <div class="pic fl" @click="jumps(item.video_id,item.type,item.isDelete)">
        <img :src="item.imgUrl" alt />
        <div class="type" v-if="item.type==1">点播课</div>
        <div class="type" v-if="item.type==2">直播课</div>
        <div class="type" v-if="item.type==3">线下课</div>
      </div>
      <div class="infos clearfix fr">
        <h3>{{item.title}}</h3>
        <div class="zai">
          <i class="el-icon-s-custom"></i>
          {{item.AllUserLearnCount}}人在学
        </div>
        <div class="hou clearfix">
          <div class="money fl" v-if="item.price!=0">￥{{item.price}}</div>
          <div class="money fl" v-else>免费</div>
          <div class="deleat fr" @click="onClose(item.video_id)">
            <i class="el-icon-delete"></i>
            删除
          </div>
        </div>
      </div>
    </div>
    <div class="pageing"  v-if="contountbox.arr != undefined && contountbox.arr.length != 0">
      <span @click="pageindex">首页</span>
      <el-pagination
        small
        layout="prev, pager, next"
        prev-text="上一页"
        next-text="下一页"
        :background="true"
        :total="contountbox.total_pages==null?1:contountbox.total_pages"
        :page-size="1"
        @current-change="currentchange"
        :current-page="page"
      ></el-pagination>
      <span @click="pageend">尾页</span>
    </div>
  </div>
</template>

<script>
import { Pagination, Tabs, TabPane,Message } from "element-ui";
import utilFile from "@/ace/ace.js";
export default {
  components: {
    [Pagination.name]: Pagination,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Message.name]: Message,
  },
  data() {
    return {
      activeName: '',
      page: 1,
      contountbox: []
    };
  },
  watch:{
    activeName(newvalue){
      this.page = 1;
      this.collectionlist = [];
      this.collection();
    },
    page(newvalue) {
      this.page = newvalue;
      this.collection();
    }
  },
  methods: {
    //分页
    currentchange(page) {
      this.page = page;
    },
    pageindex() {
      this.page = 1;
    },
    pageend() {
      this.page = this.contountbox.total_pages;
    },
    handleClick(tab, event) {
     
    },
    jumps(id, type, isDelete) {
      if (isDelete != undefined && isDelete == 1) {
        Message.closeAll();
        Message({
          showClose: true,
          message: "该课程已被下架",
          type: "warning"
        });
      } else {
        this.$router.push({
          path: "/detailsclass",
          query: {
            id
          }
        });
      }
    },
    onClose(video_id) {
      var data = utilFile.encrypt(
        JSON.stringify({
          video_id: video_id
        })
      );

      this.$axios({
        method: "post",
        url: `/api/user.delVideoCollection?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 200) {
          Message.closeAll();
          Message({
            showClose: true,
            message: res.data.msg,
            type: "success"
          });
          this.contountbox.arr.forEach((item, index) => {
            if (item.video_id == video_id) {
              this.contountbox.arr.splice(index, 1);
            }
          });
        }
      });
    },
    collection(type) {
      var data = utilFile.encrypt(
        JSON.stringify({
          page: this.page,
          type:this.activeName,
        })
      );

      this.$axios({
        method: "post",
        url: `/api/user.videoCollectionList?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        }
        if (res.data.data != undefined) {
          let arr = JSON.parse(utilFile.decrypt(res.data.data));
          this.contountbox = arr;
        }
      });
    }
  },
  mounted() {
  }
};
</script>

<style scoped>
.classitems {
  padding: 25px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #edf1f2;
  cursor: pointer;
}
.classitems .pic {
  width: 210px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  height: 119px;
}

.classitems .pic img{
  min-height: 100%;
}

.classitems .pic .type {
  position: absolute;
  font-size: 14px;
  color: #ffffff;
  padding: 7px 12px;
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.6);
  left: 10px;
  top: 10px;
}

.classitems .infos {
  width: 690px;
  text-align: left;
}

.classitems .infos h3 {
  font-size: 18px;
  color: #000000;
  margin-bottom: 16px;
  margin-top: 9px;
}

.classitems .infos .zai {
  font-size: 14px;
  color: #878787;
  margin-bottom: 30px;
}

.classitems .infos .zai i {
  color: #878787;
}

.classitems .hou {
  width: 100%;
}

.classitems .hou .money {
  font-size: 24px;
  color: red;
  font-weight: bold;
  line-height: 43px;
}

.classitems .hou .btn {
  width: 122px;
  font-size: 18px;
  color: #ffffff;
  border-radius: 3px;
  background-color: #38a0ff;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
  margin-left: 18px;
}

.classitems .hou .btn.on {
  background-color: #ff8c59;
}

.classitems .hou .btn.active {
  color: #1e1e1e;
  background-color: #f3f4f6;
}

.classitems .deleat {
  width: 120px;
  line-height: 45px;
  text-align: center;
  background-color: #f3f4f6;
  color: #000000;
  border-radius: 3px;
  cursor: pointer;
}

.classitems .deleat i {
  color: #000000;
}
</style>